import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import GPA from "../../Assets/Projects/GPA-calc.png";
import shopify from "../../Assets/Projects/shopify.png";
import magma from "../../Assets/Projects/magma.png";
import emojicrypt from "../../Assets/Projects/emojicrypt.png";
import flixflow from "../../Assets/Projects/flix-flow.png";
import travelz from "../../Assets/Projects/worldTravel.png"
import tictactoe from "../../Assets/Projects/tic-tac-toe.png";
import emojihub from "../../Assets/Projects/emoji-hub.png";
import portfolio from "../../Assets/Projects/portfolio.png";
import donorhub from "../../Assets/Projects/donorhub.png";
import trimrr from "../../Assets/Projects/trimrr.png";
import hirrd from "../../Assets/Projects/hirrd.png";
import taskme from "../../Assets/Projects/taskme.png";
import quantis from "../../Assets/Projects/quantis.png";
import MultiThreadedProxyServer from "../../Assets/Projects/MultiThreadedProxyServer.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={MultiThreadedProxyServer}
              isNotLive={true}
              title="Multi Threaded Proxy Server"
              description="Developed a high-performance multi-threaded HTTP proxy server in C, leveraging semaphores for efficient thread synchronization and concurrent request handling. Integrated an LRU caching algorithm to optimize response times and minimize redundant server requests. Utilized key operating system concepts, including threading, mutex locks, and socket programming."
              ghLink="https://github.com/Shu4bham/MultiThreadedProxyServer"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={hirrd}
              isNotLive={false}
              title="Hirrd"
              description="Hirrd is a modern web-based platform designed to streamline the hiring process for both job seekers and recruiters. It serves as a bridge between candidates searching for opportunities and recruiters looking for the right talent. The platform features an intuitive user interface and robust functionality, enabling seamless job applications and postings."
              ghLink="https://github.com/Shu4bham/Hirrd"
              demoLink="https://hirrd-u.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={trimrr}
              isNotLive={false}
              title="Trimrr"
              description="Trimrr is a user-friendly web application designed to simplify and enhance URL management. It allows users to create short, shareable links and provides robust tracking features to monitor link performance. The platform is built with a focus on speed, efficiency, and detailed analytics, making it ideal for personal and professional use."
              ghLink="https://github.com/Shu4bham/Trimrr"
              demoLink="https://utrim.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isNotLive={false}
              title="Portfolio"
                description=" Dynamic and interactive personal portfolio website designed to showcase GitHub projects, technical skills, and resume. Built with React.js, Node.js, and Express.js, and styled using React-Bootstrap and CSS3, it offers a seamless and visually appealing experience. The multi-page layout ensures intuitive navigation, while full responsiveness guarantees optimal viewing across all devices."
              ghLink="https://github.com/shu4bham/Portfolio"
              demoLink="https://shu4bham.vercel.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emojicrypt}
              isNotLive={false}
              title="Emojicrypt"
              description="A web-based project using HTML, CSS, and JavaScript that encrypts text into emoji representations and decrypts encrypted emojis back into text. Protect your messages with fun and secure emoji encryption!"
              ghLink="https://github.com/shu4bham/Emojicrypt"
              demoLink="https://emojicrypt.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={taskme}
              isNotLive={true}
              title="TaskME"
              description="Taskme is a cloud-based task management application built on the MERN stack (MongoDB, Express.js, React.js, Node.js), designed to streamline task organization and team collaboration. It offers a secure user authentication system with role-based access control using JWT, allowing admins to efficiently manage team members and monitor progress."
              ghLink="https://github.com/Shu4bham/TaskME"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={quantis}
              isNotLive={true}
              title="Quantis"
              description="Quantis is a high-performance BigInt library designed to handle extremely large integers with precision and efficiency, implemented using Object-Oriented Programming (OOP) principles in C++. It provides a comprehensive set of operations, including addition, subtraction, multiplication, division, and modular arithmetic, ensuring seamless computation with integers far beyond the standard data type limits."
              ghLink="https://github.com/Shu4bham/Quantis"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shopify}
              isNotLive={false}
              title="Shopify"
              description="Shopify is a stylish and contemporary clothing website built with HTML, CSS, and JavaScript, aimed at delivering an immersive shopping experience to fashion enthusiasts. This project showcases a modern design with sleek aesthetics and user-friendly navigation, ensuring seamless accessibility on various mobile devices."
              ghLink="https://github.com/shu4bham/Shopify"
              demoLink="https://shu4bham-shopify.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={flixflow}
              isNotLive={false}
              title="Flix-flow"
              description="Welcome to FlixFlow, where movie tracking gets a whole lot funkier! Keep the rhythm of your movie marathon with MovieWatchr, a groovy tool to log all your watched flicks in style.Show off your funky taste with FunkyFlix Ratings, shake it up, and rate movies according to your vibe. It's all about expressing yourself!"
              ghLink="https://github.com/shu4bham/Flix-flow"
              demoLink="https://flix-flow.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={GPA}
              isNotLive={false}
              title="GPA Calculator"
              description="GPA Calculator is a web application built using HTML, CSS, and JavaScript that allows users to calculate their Grade Point Average (GPA) based on the grades they received and the credits assigned to each course. It offers a user-friendly interface where users can input the course name, grade received, and course credits for multiple courses across various semesters."
              ghLink="https://github.com/shu4bham/GPA-Calculator"
              demoLink="https://gpa-calculator-shu4bham.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={travelz}
              isNotLive={false}
              title="Travelz"
              description="A responsive travel website built using HTML and CSS offers users an immersive and seamless experience across various devices, from desktops to smartphones."
              ghLink="https://github.com/shu4bham/"
              demoLink="https://travel4worldwithus.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={donorhub}
              isNotLive={false}
              title="Donorhub"
              description="DonorHub is a modern web platform designed to connect donors with organizations and individuals in need, streamlining the donation process for maximum impact. Built with React.js for a dynamic and responsive user experience, DonorHub offers an intuitive interface that enables users to browse causes, track donations, and engage with charitable initiatives seamlessly. "
              ghLink="https://github.com/Shu4bham/Donorhub"
              demoLink="https://donor-hub.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={magma}
              isNotLive={false}
              title="Magma Clone"
              description="This is clone of the landing page of Thisismagma. Magma is a groundbreaking platform that integrates an interactive 3D model with blockchain layers, enabling collaboration between stakeholders in a secure, agile, and robust digital environment. It is a Web3 platform for all real estate stakeholders, which provides users with the ability to manage interactions between physical and digital assets. "
              ghLink="https://github.com/shu4bham/Magma"
              demoLink="https://magma-dtt.vercel.app/"
            />
          </Col>  
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={tictactoe}
              isNotLive={false}
              title="TIC-TAC-TOE"
              description="TIC-TAC-TOE is a beloved and strategic two-player game developed using HTML, CSS, and JavaScript. This GitHub repository houses the source code for the digital rendition of the classic game, providing a delightful gaming experience for users to enjoy with friends and family."
              ghLink="https://github.com/Shu4bham/TICTACTOE"
              demoLink="https://shu4bham-tic-tac-toe.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emojihub}
              isNotLive={false}
              title="Emoji Hub"
              description="Emoji Hub is a web application that allows users to conveniently browse and explore a wide range of emojis. With a user-friendly interface, it provides an interactive way to discover and utilize emojis for various purposes."
              ghLink="https://github.com/Shu4bham/Emoji-Hub-web-app"
              demoLink="https://shu4bham.github.io/Emoji-Hub-web-app/"
            />
          </Col>

     

          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isNotLive={false}
              title="Prank Yourself"
              description="My name is giovanni giorgio but everybody calls me giorgio"
              ghLink="https://youtube.com/shorts/EmGpHyR8iyM?feature=share"
              demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
